import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { saveStep4Callback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import {
  workflowDetails,
  workflowValidStep4State
} from 'Pages/Workflow/recoil/state/data'
import { pageState, wizardSteps } from 'Pages/Workflow/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'

const Footer = () => {
  const intl = useIntl()
  const history = useHistory()

  const { Draft } = useRecoilValue(workflowDetails)
  const setWizardStep = useSetRecoilState(wizardSteps)
  const saveStep = useRecoilCallback(saveStep4Callback, [])
  const validStep4 = useRecoilValue(workflowValidStep4State)
  const [{ edit, saveAndExit }, setPageState] = useRecoilState(pageState)

  const handleBack = () => {
    setWizardStep((prev) => ({ ...prev, wizardStep: 3 }))
  }

  const exit = () => {
    setPageState((prev) => ({
      ...prev,
      isDirty: false,
      saveAndExit: true
    }))
  }

  useEffect(() => {
    saveAndExit &&
      history.push(`/automation/workflows/list?saved=1&edit=${edit ? 1 : 0}`)
  }, [saveAndExit])

  const handleSaveExit = () => {
    saveStep({ onSuccess: exit })
  }

  return (
    <Flex alignItems='center' justifyContent='space-between' columnGap='8px'>
      <Button
        kind={BUTTON_VARIANT_SECONDARY}
        data-mu-test='back'
        onClick={handleBack}
      >
        {intl.formatMessage({ id: 'Load.AutomationWorkflow.PrevStepButton' })}
      </Button>

      <Flex justifyContent='flex-end' columnGap='8px'>
        {Draft && (
          <Button
            kind={BUTTON_VARIANT_SECONDARY}
            data-mu-test='save-exit'
            onClick={handleSaveExit}
          >
            {intl.formatMessage({ id: 'Load.AutomationWorkflow.Draft' })}
          </Button>
        )}
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            data-mu-test='next'
            onClick={saveStep}
            disabled={!validStep4}
          >
            {intl.formatMessage({
              id: 'Load.AutomationWorkflow.NextStepButton'
            })}
          </Button>
        </FlexItem>
      </Flex>
    </Flex>
  )
}

export default Footer
